import api from './api';

export const getNotifications = async () => {
  const data = await api('/notifications');
  return data;
};

export const createNotification = async (notificationData) => {
  const data = await api('/notifications/broadcast', {
    method: 'POST',
    body: JSON.stringify(notificationData)
  });
  return data;
};

export const getAdminBroadcasts = async () => {
  const data = await api('/notifications/broadcast/admin');
  return data;
};

export const getEmployeeBroadcasts = async () => {
  const data = await api('/notifications/broadcast/employee');
  return data;
};

export const markBroadcastAsRead = async (id) => {
  const data = await api(`/notifications/broadcast/${id}/read`, {
    method: 'PUT'
  });
  return data;
};
